<template>
	<dialog-slot
			is-full-screen
			:title="dialogTitle"
			@updateClose="closeDialog"
			@updateSave="onSave"
			apply-text="Save"
			:is-btn-safe="$v.$invalid"
	>
		<template #subTitle>
			<div class="customersHead-subTitleDialogTrip">
				<span v-if="dialogSubTitle"> #<span class="id">{{ dialogSubTitle }}</span></span>
			</div>
		</template>
		<template #topButtons>
			<div class="buttonGroupsDialogTrip">
				<v-btn
						@click="onAddImportGPT"
						color="blue"
						depressed
						:disabled="!isNewTrip"
				>
					Add import GPT
				</v-btn>
				<v-btn
						@click="onAddLoad"
						color="success"
						depressed
				>
					<span class="btnIco"><svg-sprite icon-id="plus" width="20" height="20"></svg-sprite></span>
					<span class="btnText">Add load</span>
				</v-btn>
				<v-btn
						@click="onRemoveTrip"
						color="error"
						depressed
						:disabled="isNewTrip"
				>
					<span class="btnIco"><svg-sprite icon-id="deleteItem" width="20" height="20"></svg-sprite></span>
					<span class="btnText">Remove trip</span>

				</v-btn>
			</div>
		</template>

		<div class="wrapDialogTrip">
			<div class="dialogMain">
				<div class="sidebar">
					<field
							margin="0"
							label="Driver"
							placeholder="Select driver name"
							@updateAutocomplete="onAutocomplete($event, 'driver')"
							:autocompleteValue="driver"
							:items="filterDriverList"
							:isClearable="false"
							is-autocomplete
							is-required
							:classError="errDriver"
					></field>
					<field
							margin="10px 0"
							label="Second driver"
							placeholder="Select driver name"
							@updateAutocomplete="onAutocomplete($event, 'driverSecond')"
							:autocompleteValue="driverSecond"
							:items="filterDriverList"
							:isClearable="false"
							is-autocomplete
							:is-disabled="!driver"
					></field>
					<field
							margin="10px 0"
							label="Truck"
							placeholder="Select truck number"
							@updateAutocomplete="onAutocomplete($event, 'truck')"
							:autocompleteValue="truck"
							:items="filterTruckList"
							:isClearable="false"
							is-autocomplete
							is-required
							:is-disabled="!driver"
							:classError="errTruck"
					></field>
					<field
							margin="10px 0 20px"
							label="Trailer"
							placeholder="Select trailer number"
							@updateAutocomplete="onAutocomplete($event, 'trailer')"
							:autocompleteValue="trailer"
							:items="filterTrailerList"
							:isClearable="false"
							is-autocomplete
							is-required
							:is-disabled="!driver"
							:classError="errTrailer"
					></field>
					<div class="sidebar_item">
						<span class="text">Customer:</span>
						<span class="value">{{ customer }}</span>
					</div>
					<div class="sidebar_item">
						<span class="text">Trailer type:</span>
						<span class="value">{{ trailerType }}</span>
					</div>
					<field
							margin="20px 0 10px"
							label="Dispatcher"
							placeholder="Select dispatcher name"
							@updateAutocomplete="onAutocomplete($event, 'dispatcher')"
							:autocompleteValue="dispatcher"
							:items="filterDispatcherList"
							:isClearable="false"
							is-autocomplete
							is-required
							:classError="errDispatcher"
					></field>

					<div class="sidebar_item">
						<span class="text">Total mileage:</span>
						<span class="value">{{ totalMileage }}<svg-sprite icon-id="icon_mi" width="20" height="20"></svg-sprite></span>
					</div>

					<div class="sidebar_item">
						<span class="text">Total gross:</span>
						<span class="value"><svg-sprite icon-id="icon_dollars" width="8" height="14"></svg-sprite>{{ totalGross }}</span>
					</div>

					<div class="sidebar_item">
						<span class="text">Total RMP:</span>
						<span class="value">{{ totalRPM }} <svg-sprite icon-id="icon_dollars" width="8" height="14"></svg-sprite>/mi</span>
					</div>

					<div class="sidebar_item">
						<span class="text">Bill to factoring:</span>
						<span class="value"><svg-sprite icon-id="icon_dollars" width="8" height="14"></svg-sprite>{{ bill_factoring }}</span>
					</div>

					<NavigationAddress
							:items="getListItems"
					></NavigationAddress>

					<div class="wrapperMap">
						<v-btn
								v-if="!isShowMapBTN"
								@click="onShowMap"
								depressed
								:disabled="!isLocationOk"
								block
								color="success"
						>

							<span class="btnIco"><svg-sprite icon-id="routeMap" width="20" height="20"></svg-sprite></span>
							<span class="btnText">Show map</span>
						</v-btn>

						<!-- ✅ текст ошибки под кнопкой -->
						<div v-if="mapValidationError" class="mapValidationError">
							{{ mapValidationError }}
						</div>

						<map-wrap
								v-if="isShowMapBTN"
								:key="mapInstanceKey"
								:items="getMapItems"
						></map-wrap>
					</div>

				</div>
				<div class="loadsWrap">
					<load
							v-for="(item, index) in loads"
							:key="item.load_id"
							:index="index"
							:load="item"
							:brokers="tripDialogDriverBrokers"
							:default-location="defaultLocation"
							:old-route="old_route"
							:is-load-length="loadLength"
							:invalidPickup="$v.loads.$each.$iter[index].pickup.$invalid"
							:invalidDelivery="$v.loads.$each.$iter[index].delivery.$invalid"
							:errorsPickup="getPickupErrors(index)"
							:errorsDelivery="getDeliveryErrors(index)"
							:errorsGeneral="getGeneralErrors(index)"
							:errorsMileage="getMileageErrors(index)"
							@updateLoadAutocompletePickup="onLoadAutocompletePickup($event, index)"
							@updateLoadAutocomplete="onLoadAutocomplete($event, index)"
							@updateLoadInput="onLoadInput($event, index)"
							@updateLoadPickupInput="onLoadPickupInput($event, index)"
							@updateLoadPickupTime="onLoadPickupInput($event, index)"
							@updateDeleteItemPickup="onLoadDeleteItemPickup($event, index)"
							@updateAddItemPickup="onAddItemPickup($event, index)"
							@updateRemoveLoad="onRemoveLoad($event, index)"
							@updateSearchText="onSearchText($event, index)"
							@updateSearchTextPickup="onSearchTextPickup($event, index)"
							@updateAddItem="onAddItem($event, index)"
							@updateEditItem="onEditItem($event, index)"
							@updateLoadSwitch="onLoadSwitch($event, index)"
							@updateLoadGuide="onLoadGuide($event)"
							@updateNewItem="setNewItem($event, index)"
							@updateCustomIconButton="onCustomIconButton($event, index)"
							@updateOpenOldTrip="onOpenOldTrip"
							@updateCreateInvoice="onCreateInvoice"
							@updateGenerateFilePPW="onGenerateFilePPW"
					></load>
				</div>
			</div>
		</div>

		<dialog-creating-broker
				v-if="isCreatingBroker"
				:newBroker="searchText"
				:mc="searchMc"
				@updateCloseBrokerDialog="closeDialogCreatingBroker"
				@updateSaveBroker="onCreatingBroker"
		></dialog-creating-broker>

		<payments-drawer
				v-if="isPaymentsDrawer"
				:active-item="activeItem"
				@updateSave="onPaymentsDrawerSave"
				@updateClose="onPaymentsDrawerClose"
		></payments-drawer>

		<note-dialog
				v-if="isDialogNote"
				:active-item="activeItem"
				@updateSave="onSaveNote"
				@updateClose="onCloseNoteDialog"
		></note-dialog>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				:textRemoveSave="textRemoveSave"
				:textRemoveClose="textRemoveClose"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<preview-doc v-if="linkPreviewDoc" @clear-link="clearLinkPreviewDoc" :link-doc="linkPreviewDoc"></preview-doc>
		<dialog-slot
				v-if="isGuideDialogFile"
				title="Files guide"
				@updateClose="onCloseGuideDialogFile()"
				width="340px"
				:is-save="false"
		>
			<div>{{ guideFile1 }}</div>
			<br>
			<div>{{ guideFile2 }}</div>
		</dialog-slot>

		<dialog-slot
				v-if="isGuideDialogPaperWork"
				title="PaperWork info"
				@updateClose="onCloseGuideDialogPaperWork()"
				width="340px"
				:is-save="false"
		>
			<div>PPW can be created only when all the files is ready:</div>
			<br>
			<ul>
				<li>Confirmation</li>
				<li>BOL</li>
				<li>Invoice</li>
			</ul>
		</dialog-slot>

<!--		-->
<!--		<guide-dialog-->
<!--				v-if="isGuideDialogFile"-->
<!--				title="Files guide"-->
<!--				@updateClose="onGuideClose(pageFiles)"-->
<!--		>-->
<!--			<template slot="main">-->

<!--			</template>-->
<!--		</guide-dialog>-->
<!--		<guide-dialog-->
<!--				v-if="isGuideDialogPaperWork"-->
<!--				title="PaperWork info"-->
<!--				@updateClose="onGuideClose(pagePaperWork)"-->
<!--		>-->
<!--			<template slot="main">-->
<!--				-->
<!--			</template>-->
<!--		</guide-dialog>-->

		<create-invoice-dialog
				v-if="isCreateInvoice"
				@updateGenerateInvoice="onGenerateInvoice"
				@updateClose="onGenerateInvoiceClose"
		></create-invoice-dialog>
		<generate-file-p-p-w
				v-if="isGenerateFilePPW"
				:items="tripPPWFilesTable"
				@updateClose="onGenerateFilePPWClose"
				@updatePPWFilesClickButton="onPPWFilesClickButton"
				@updateGeneratePPWFilesSelected="onGeneratePPWFilesSelected"
		></generate-file-p-p-w>
		<view-selected-p-p-w-files
				v-if="isViewFilePPW"
				:items="tripSelectedPPWFilesTable"
				@updateClose="onViewFilePPWClose"
				@updatePPWFilesClickButton="onPPWFilesClickButton"
		></view-selected-p-p-w-files>
		<send-ppw-file
				v-if="isSendPpwFile"
				@updateClose="onSendPpwFileClose"
				@updateSendPpwFile="onSendPpwFileButton"
		></send-ppw-file>
		<dialog-g-p-t
				v-if="isAddImportGPT"
				title="Add Import GPT"
				@updateClose="onCloseDialogGPT"
				@updateSaveValue="onSaveValue"
				@updateAutocomplete="onAutocomplete"
				:filterDriverList="filterDriverList"
				:filterTruckList="filterTruckListAll"
				:filterTrailerList="filterTrailerListALL"
				:brokers="tripDialogDriverBrokers"
				:createdBroker="createdBrokerForGPT"
				@updateSearchText="onSearchText($event, 0)"
				@updateInput="onInputGPT($event, 0)"
		></dialog-g-p-t>
	</dialog-slot>

</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// shared
// modules
import PreviewDoc from "@/modules/invoices/preview";
// components
import Load from "@/components/Dispatch/Trips/DialogTrip/Load/Load.vue";
import DialogCreatingBroker from "@/components/Dispatch/Trips/DialogTrip/DialogCreatingBroker/DialogCreatingBroker.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import PaymentsDrawer from "@/components/Dispatch/Trips/DialogTrip/Load/Payments/PaymentsDrawer";
import NoteDialog from "@/components/Dispatch/Trips/DialogTrip/Load/Notes/NoteDialog";
import CreateInvoiceDialog from "@/components/Dispatch/Trips/DialogTrip/Load/CreateInvoiceDialog/CreateInvoiceDialog";
import GenerateFilePPW from "@/components/Dispatch/Trips/DialogTrip/Load/PaperWork/GenerateFilePPW";
import ViewSelectedPPWFiles from "@/components/Dispatch/Trips/DialogTrip/Load/PaperWork/ViewSelectedPPWFiles";
import SendPpwFile from "@/components/Dispatch/Trips/DialogTrip/Load/PaperWork/SendPpwFile";
import NavigationAddress from "@/components/Dispatch/Trips/DialogTrip/NavigationAddress/NavigationAddress";
const MapWrap = () => import("@/components/Dispatch/Trips/DialogTrip/MapWrap/MapWrap.vue");
// shared
// services
import { getAppUrl } from "@/services";
// helper
import getClonedArray from "@/helper/getClonedArray";
import { downloadDoc } from "@/helper/getDownloadDoc";

// Constants
import { PAGE } from "@/constants/constants";
import { TITLE, TEXT, KEY } from "@/components/Dispatch/Trips/DialogTrip/constants";
// validate
import { validationMixin } from "vuelidate";
// import { required, minLength } from "vuelidate/lib/validators";
import { required } from "vuelidate/lib/validators";
// import moment from "moment/moment";
import moment from 'moment-timezone';
import DialogGPT from "@/components/Dispatch/Trips/DialogTrip/DialogGPT/DialogGPT.vue";
import { buildStop } from '@/helper/helpersTrip';
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "DialogTrip",
	mixins: [ validationMixin ],
	components: {
		DialogSlot,
		DialogGPT,
		PaymentsDrawer,
		Load,
		DialogCreatingBroker,
		DialogRemove,
		NoteDialog,
		PreviewDoc,
		CreateInvoiceDialog,
		GenerateFilePPW,
		ViewSelectedPPWFiles,
		SendPpwFile,
		NavigationAddress,
		MapWrap,
	},
	props: {
		flag: [ String, Number ],
	},

	computed: {
		...mapGetters([
			"tripDialog",
			"tripDialogConnections",
			"tripDialogDriverBrokers",
			"tripDialogDriverNewBrokers",
			"tripPPWFiles",
			"tripPPWFilesTable",
			"tripSelectedPPWFiles",
			"tripSelectedPPWFilesTable",
			"extractGPT",
		]),
		loadLength() {
			const activeLoads = this.loads.filter(obj => obj.status !== 'delete');
			return activeLoads.length === 1;
		},
		dialogTitle() {
			if ( this.flag !== 'new' ) return `Edit trip`;
			return 'Add trip';
		},
		isNewTrip() {
			return this.flag === 'new';
		},
		getListItems() {
			const currentDate = moment();
			// Устанавливаем часовой пояс Чикаго (Central Time Zone)
			const chicagoTimezone = 'America/Chicago';
			currentDate.tz(chicagoTimezone);
			// Форматируем дату и время в желаемом формате 'YYYY-MM-DD HH:mm:ss'
			const formattedDateTime = currentDate.format('YYYY-MM-DD HH:mm:ss');
			const nawTime = {
				date: formattedDateTime,
				type: 'now'
			};
			const parseDate = (dateString) => {
				return new Date(dateString);
			};
			let information = [];

			this.loads.map(load => {
				const delivery = load.delivery.map(item => ({
					load_id: load.load_id,
					date: item.date_time,
					type: 'delivery',
					...item.loction
				}));
				const pickup = load.pickup.map(item => ({
					load_id: load.load_id,
					date: item.date_time,
					type: 'pickup',
					...item.loction
				}));
				information = information.concat(pickup);
				information = information.concat(delivery);
			});
			information.push(nawTime);
			information.sort((a, b) => parseDate(a.date) - parseDate(b.date));

			return information;
		},
		getMapItems() {
			const parseDate = function(dateString) {
				return new Date(dateString);
			};

			const information = this.collectMapPoints();

			if (!information.length) {
				return { start: '', end: '', waypoints: [] };
			}

			information.sort(function(a, b) {
				return parseDate(a.date) - parseDate(b.date);
			});

			if (information.length < 2) {
				return { start: '', end: '', waypoints: [] };
			}

			return {
				start: information[0].city + ', ' + information[0].state + ', ' + information[0].zip_code,
				end: information[information.length - 1].city + ', ' + information[information.length - 1].state + ', ' + information[information.length - 1].zip_code,
				waypoints: information.slice(1, information.length - 1).map(function(item) {
					return item.city + ', ' + item.state + ', ' + item.zip_code;
				}),
			};
		},

		errDriver() {
			return !!this.$v?.driver?.id?.$error; 
		},
		errTruck() {
			return !!this.$v?.truck?.id?.$error; 
		},
		errTrailer() {
			return !!this.$v?.trailer?.id?.$error; 
		},
		errDispatcher() {
			return !!this.$v?.dispatcher?.id?.$error; 
		},

	},
	data() {
		return {
			createdBrokerForGPT: null,
			pageFiles: PAGE.TRIP_FILES,
			pagePaperWork: PAGE.TRIP_PAPER_WORK,
			guideFile1: TEXT.GUIDE_FILE_1,
			guideFile2: TEXT.GUIDE_FILE_2,
			filterDriverList: null,
			dispatcher_id: null,
			filterDispatcherList: null,
			filterLoadFiletTypeList: null,
			filterTrailerList: null,
			filterTrailerListALL: null,
			filterTruckList: null,
			filterTruckListAll: null,
			serviceList: null,
			defaultLocation: null,
			isAddImportGPT: null,
			dispatcher: null,
			division: null,
			division_id: null,
			driver: {
				id: null,
				tarp: null,
				value: null,
			},
			frozen: null,
			loads: [],
			mileage_trip: null,
			old_route: null,
			secDriver: null,
			tarp: null,
			trailer: null,
			trailerType: null,
			trip_id: null,
			truck: null,
			customer: null,

			dialogSubTitle: null,
			driverSecond: null,
			totalMileage: 0,
			totalGross: 0,
			totalRPM: 0,
			bill_factoring: null,

			isPaymentsDrawer: false,
			isCreatingBroker: false,
			searchText: null,
			searchTextIndex: null,
			searchMc: null,

			activeItem: null,
			activeItemIndex: null,
			activeLoad: null,
			activeLoadIndex: null,

			isDialogRemove: null,
			titleRemove: null,
			textRemove: null,
			flagRemove: null,

			isDialogNote: false,
			activeNote: null,

			linkPreviewDoc: null,

			isGuideDialogFile: false,
			isGuideDialogPaperWork: false,

			isCreateInvoice: false,
			isGenerateFilePPW: false,
			isViewFilePPW: false,
			isSendPpwFile: false,
			isShowMap: false,

			isShowMapBTN: false,
			isLocationOk: false,
			mapValidationError: '',
			mapInstanceKey: 0,

			isSaveStatus: false,
			textRemoveSave: 'YES',
			textRemoveClose: 'NO',
			file: {
				name: "",
				value: ""
			},
			chicagoDateTime: new Date(new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })),
			isGPTFileError: false,
			isGPTFileSuccess: false,
			ai_status: false,
		};
	},
	validations() {
		return {
			driver: {
				id: { required }
			},
			truck: {
				id: { required }
			},
			trailer: {
				id: { required }
			},
			dispatcher: {
				id: { required }
			},
			loads: {
				$each: {
					load_type_id: { required },
					broker_number: { required },
					broker_id: { required },
					mc: { required },
					rate: { required },
					pick_up_mileage: { required },
					mileage_empty: { required },
					// file: { required, minLength: minLength(1), },
					pickup: {
						$each: {
							date_time: { required },
							loction: {
								state_id: { required },
							}
						}
					},
					delivery: {
						$each: {
							date_time: { required },
							loction: {
								state_id: { required },
							}
						}
					},
				},
			},
		};
	},
	watch: {
		extractGPT(val) {
			this.extractGPTUpdate(val);
		},
		tripDialogConnections: {
			handler() {
				this.updateConnections();
			},
			deep: true
		},
		loads: {
			deep: true,
			handler() {
				this.validateMapRoute();
			}
		},
	},

	methods: {
		...mapActions([
			"getTripDialog",
			"getTripDialogConnections",
			"getTripDialogBrokers",
			"addNewBrokersTripDialog",
			"getLocationTripDialog",
			"getMileage",
			'setAlert',
			'saveTrip',
			'generateBilling',
			'removeBillingInvoiced',
			'getPPWFiles',
			'createPPWFile',
			'sendPPWFile',
			'getSelectedPPWFiles',
			'getIdLoad',
		]),

		onCloseGuideDialogFile() {
			this.isGuideDialogFile = false;
		},
		onCloseGuideDialogPaperWork() {
			this.isGuideDialogPaperWork = false;
		},
		// onShowMap() {
		// 	this.isShowMapBTN = true;
		// },

		collectMapPoints() {
			const points = [];

			if (!Array.isArray(this.loads) || !this.loads.length) return points;

			this.loads.forEach(function(load) {
				// если у тебя есть статусы удалений — можешь тут пропускать удалённые
				// if (load && (load.status === 'delete' || load.status === 'deleted')) return;

				const loadId = load && load.load_id;

				const pickup = Array.isArray(load && load.pickup) ? load.pickup : [];
				const delivery = Array.isArray(load && load.delivery) ? load.delivery : [];

				pickup.forEach(function(item) {
					points.push({
						load_id: loadId,
						date: item ? item.date_time : null,
						type: 'pickup',
						// ⚠️ оставляю твой loction как есть
						...(item && item.loction ? item.loction : {}),
					});
				});

				delivery.forEach(function(item) {
					points.push({
						load_id: loadId,
						date: item ? item.date_time : null,
						type: 'delivery',
						...(item && item.loction ? item.loction : {}),
					});
				});
			});

			return points;
		},

		// ✅ валидация маршрута: start/end + все даты
		validateMapRoute() {
			this.mapValidationError = '';
			this.isLocationOk = false;

			const loads = Array.isArray(this.loads) ? this.loads : [];

			// 2) Проверка: у всех pickup/delivery заполнен date_time
			for (let i = 0; i < loads.length; i++) {
				const load = loads[i] || {};
				const pickup = Array.isArray(load.pickup) ? load.pickup : [];
				const delivery = Array.isArray(load.delivery) ? load.delivery : [];

				for (let p = 0; p < pickup.length; p++) {
					if (!pickup[p] || !pickup[p].date_time) {
						this.mapValidationError = 'Map error: Please fill date/time for all pickup points.';
						return false;
					}
				}

				for (let d = 0; d < delivery.length; d++) {
					if (!delivery[d] || !delivery[d].date_time) {
						this.mapValidationError = 'Map error: Please fill date/time for all delivery points.';
						return false;
					}
				}
			}

			// 1) Проверка: start/end существуют и заполнены
			const points = this.collectMapPoints();

			if (points.length < 2) {
				this.mapValidationError = 'Map error: Please add at least 2 locations (start and end).';
				return false;
			}

			// сортировка по дате
			points.sort(function(a, b) {
				return new Date(a.date) - new Date(b.date);
			});

			const first = points[0] || {};
			const last = points[points.length - 1] || {};

			const hasFirst =
					!!first.city && !!first.state && !!first.zip_code;

			const hasLast =
					!!last.city && !!last.state && !!last.zip_code;

			if (!hasFirst || !hasLast) {
				this.mapValidationError = 'Map error: Start and End must have City, State and ZIP code.';
				return false;
			}

			// ✅ всё ок
			this.isLocationOk = true;
			this.mapValidationError = '';
			return true;
		},

		onShowMap() {
			// на всякий случай: если что-то поменялось — перепроверим
			if (!this.validateMapRoute()) {
				this.isShowMapBTN = false;
				return;
			}
			this.mapInstanceKey += 1;
			this.isShowMapBTN = true;
		},

		// Безопасно превращаем $iter в массив по индексам
		_iterToArray($iter) {
			if (!$iter) return [];
			if (Array.isArray($iter)) return $iter;
			if (typeof $iter === 'object') {
				const arr = [];
				Object.keys($iter).forEach(k => {
					const i = Number(k);
					arr[i] = $iter[k];
				});
				return arr;
			}
			return [];
		},

		getPickupErrors(loadIndex) {
			const res = {};
			const vLoad = this.$v?.loads?.$each?.$iter?.[loadIndex];
			if (!vLoad || !vLoad.pickup || !vLoad.pickup.$each) return res;

			const vList = this._iterToArray(vLoad.pickup.$each.$iter);
			vList.forEach((vItem, idx) => {
				if (!vItem) return;
				res[idx] = {
					date_time: !!vItem?.date_time?.$error,
					location: !!vItem?.loction?.state_id?.$error,
				};
			});
			return res;
		},

		getDeliveryErrors(loadIndex) {
			const res = {};
			const vLoad = this.$v?.loads?.$each?.$iter?.[loadIndex];
			if (!vLoad || !vLoad.delivery || !vLoad.delivery.$each) return res;

			const vList = this._iterToArray(vLoad.delivery.$each.$iter);
			vList.forEach((vItem, idx) => {
				if (!vItem) return;
				res[idx] = {
					date_time: !!vItem?.date_time?.$error,
					location: !!vItem?.loction?.state_id?.$error,
				};
			});
			return res;
		},
		getGeneralErrors(loadIndex) {
			const vLoad =
					this.$v?.loads?.$each?.$iter &&
					this.$v.loads.$each.$iter[loadIndex];

			return {
				load_type_id: !!vLoad?.load_type_id?.$error,
				broker_number: !!vLoad?.broker_number?.$error,
				broker_id: !!vLoad?.broker_id?.$error,
				mc: !!vLoad?.mc?.$error,
				rate: !!vLoad?.rate?.$error,
			};
		},
		getMileageErrors(loadIndex) {
			const vLoad = this.$v?.loads?.$each?.$iter?.[loadIndex];
			return {
				pick_up_mileage: !!vLoad?.pick_up_mileage?.$error,
				mileage_empty: !!vLoad?.mileage_empty?.$error,
			};
		},

		onCloseDialogGPT() {
			this.isAddImportGPT = false;
			this.createdBrokerForGPT = null;

			this.extractGPTUpdate(this.extractGPT);
			if (this.isGPTFileError) {
				this.titleRemove = "Invalid file.";
				this.textRemove = "❌ Invalid document format. Please try a different file.";
				this.textRemoveSave = 'Add File';
				this.textRemoveClose = 'Close';
				this.flagRemove = 'gptFileError';
				this.isDialogRemove = true;
			}
			if (this.isGPTFileSuccess) {
				this.titleRemove = "File processed successfully.";
				this.textRemove = "🎉 Please check that all the details are correct";
				this.textRemoveSave = 'OK';
				this.textRemoveClose = 'Close';
				this.flagRemove = 'gptFileSuccess';
				this.isDialogRemove = true;
			}
		},
		onAddImportGPT() {
			this.isAddImportGPT = true;
		},

		async onGeneratePPWFilesSelected( selected ) {
			const { load_id } = this.activeLoad;
			const filteredFiles = this.tripPPWFiles.file.filter(file => {
				return selected.some(selectedFile => file.load_image_id === selectedFile.id);
			});
			const filteredInvoice = selected.find(selectedItem => selectedItem.id === 'Invoice');
			const value = {
				file: filteredFiles,
				invoice: filteredInvoice ? this.tripPPWFiles.invoice : {}
			};
			const updateGeneratePPWFile = await this.createPPWFile({ id: load_id, value });
			const { ppw } = updateGeneratePPWFile;
			const { create_at, file, name, ppw_created_by } = ppw;

			this.activeLoad.ppw = 1;
			this.activeLoad.ppw_created_by = ppw_created_by;
			this.activeLoad.ppw_date = create_at;
			this.activeLoad.ppw_file = file;
			this.activeLoad.ppw_name = name;

			this.onGenerateFilePPWClose();
			this.loads = getClonedArray(this.loads);
		},

		onPPWFilesClickButton({ item }) {
			const { url } = item;
			this.linkPreviewDoc = getAppUrl + url;
		},

		async onGenerateFilePPW({ load }) {
			this.activeLoad = load;
			await this.getPPWFiles(load.load_id);
			this.isGenerateFilePPW = true;
		},
		onGenerateFilePPWClose() {
			this.activeLoad = null;
			this.isGenerateFilePPW = false;
		},

		onCreateInvoice({ load }) {
			this.activeLoad = load;
			this.isCreateInvoice = true;
		},
		onGenerateInvoiceClose() {
			this.activeLoad = null;
			this.isCreateInvoice = false;
		},
		async onGenerateInvoice(args) {
			this.isCreateInvoice = false;
			const { ref, type, date } = args;
			const file = '';
			const { load_id } = this.activeLoad;
			const value = { ref, type, date, file, load_id };
			if ('billingDelete' in this.activeLoad.billing) {
				delete this.activeLoad.billing.billingDelete;
			}

			await this.generateBilling(value);
			this.loads = getClonedArray(this.loads);

		},
		
		onCustomIconButton(argsValue, index) {
			const { load, args } = argsValue;
			const { key, btn } = args;
			if (key === 'loaded') this.onGetMileageLoaded({ load, index, key });
			if (key === 'empty') this.onGetMileageEmpty({ load, index, key });
			if (key === 'filePPW' && btn === 'icon_send') this.onSendPpwFile(load);
			if (key === 'filePPW' && btn === 'icon_view') this.onViewSelectedPPWFiles(load, index);
			if (key === 'filePPW' && btn === 'icon_download') downloadDoc({ status: true, name: load.ppw_file.split('/').pop(), url: getAppUrl + load.ppw_file ?? '' });
			if (key === 'filePPW' && btn === 'deleteItem') this.onRemovePPWFile(load, index);
			if (key === 'fileBilling' && btn === 'deleteItem') this.onRemoveBillingInvoiced(load, index);
			if (key === 'fileBilling' && btn === 'icon_view') this.linkPreviewDoc = getAppUrl + load.billing.file;
			if (key === 'fileBilling' && btn === 'icon_download') downloadDoc({ status: true, name: load.billing.file.split('/').pop(), url: getAppUrl + load.billing.file ?? '' });
		},
		onSendPpwFile(load) {
			this.activeLoad = load;
			this.isSendPpwFile = true;
		},
		onSendPpwFileClose() {
			this.activeLoad = null;
			this.isSendPpwFile = false;
		},
		async onSendPpwFileButton({ data }) {
			const id = this.activeLoad.load_id;
			await this.sendPPWFile({ id, value: data });
			this.onSendPpwFileClose();
		},
		onViewFilePPWClose() {
			this.activeLoad = null;
			this.isViewFilePPW = false;
		},
		async onViewSelectedPPWFiles(load) {
			this.activeLoad = load;
			await this.getSelectedPPWFiles(load.load_id);
			this.isViewFilePPW = true;
		},
		onRemovePPWFile(load, index) {
			this.activeLoad = load;
			this.activeLoadIndex = index;
			this.titleRemove = TITLE.REMOVE_PPW_FILE;
			this.textRemove = TEXT.REMOVE_PPW_FILE;
			this.flagRemove = KEY.PPW_FILE;
			this.textRemoveSave = 'YES';
			this.textRemoveClose = 'NO';
			this.isDialogRemove = true;
		},
		updateRemovePPWFile() {
			this.activeLoad.ppwDelete = 1;
			this.activeLoad.ppw = null;
			this.activeLoad.ppw_created_by = null;
			this.activeLoad.ppw_date = null;
			this.activeLoad.ppw_file = null;
			this.activeLoad.ppw_name = null;
			this.loads = getClonedArray(this.loads);
		},

		onRemoveBillingInvoiced(load, index) {
			this.activeLoad = load;
			this.activeLoadIndex = index;
			this.titleRemove = TITLE.REMOVE_BILLING_INVOICED;
			this.textRemove = TEXT.REMOVE_BILLING_INVOICED;
			this.flagRemove = KEY.BILLING_INVOICED;
			this.textRemoveSave = 'YES';
			this.textRemoveClose = 'NO';
			this.isDialogRemove = true;
		},
		updateRemoveBillingInvoiced() {
			this.activeLoad.billing.billingDelete = 1;
			this.activeLoad.billing.type = '';
			this.loads = getClonedArray(this.loads);

		},
		async onGetMileageEmpty({ load, index }) {
			this.$v.$touch();

			if (!this.$v.loads.$each.$iter[0].pickup.$error && !this.$v.loads.$each.$iter[0].delivery.$error) {
				const date = load.pickup[0].date_time;
				const location = load.pickup[0].loction;
				const delivery = {
					date: date,
					...location,
				};
				const old_route = this.old_route.rout[this.old_route.rout.length - 1];
				const information = [];
				information.push(old_route);
				information.push(delivery);
				const getMileage = await this.getMileage({ information });

				this.loads[index].pick_up_empty = getMileage;
				this.loads[index].mileage_empty = getMileage;
				this.loads[index].mileage_total = Number(this.loads[index].mileage_empty) + Number(this.loads[index].pick_up_mileage);
				this.updateLoadTotalMileage();
			}
		},
		async onGetMileageLoaded({ load, index }) {
			this.$v.$touch();

			if (!this.$v.loads.$each.$iter[0].pickup.$error && !this.$v.loads.$each.$iter[0].delivery.$error) {
				const delivery = load.delivery.map(item => ({
					date: item.date_time,
					...item.loction
				}));
				const pickup = load.pickup.map(item => ({
					date: item.date_time,
					...item.loction
				}));
				const information = [ ...delivery, ...pickup ];
				const getMileage = await this.getMileage({ information });
				this.loads[index].pick_up_mileage = getMileage;
				this.loads[index].mileage_total = Number(this.loads[index].mileage_empty) + Number(this.loads[index].pick_up_mileage);
				this.updateLoadTotalMileage();
			}
		},
		onAddItemPickup(args, index) {
			this.isShowMapBTN = false;
			const { flag } = args;

			this.loads[index][flag].push({
				id: null,
				load_id: this.loads[0].load_id,
				type: 0,
				company: null,
				street: null,
				shipper: null,
				shipper_id: null,
				phone: null,
				date_time: null,
				number: null,
				app: null,
				loction: {
					state_id: null,
					state: null,
					city_id: null,
					city: null,
					zip_code: null,
				},
			});
		},
		setNewItem(args, index) {
			const { e, id, name } = args;
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.file = {
					name: iFile.name,
					value: reader.result
				};
				const result = {
					created_at: null,
					dispatcher_id: null,
					dispatcher_name: null,
					image: null,
					load_id: null,
					load_image_id: null,
					to_invoice: null,
					status: 'new',
					description: this.file.name,
					newFile: this.file.value,
					typeName: name,
					type: id,
				};
				this.loads[index].file.push(result);
			};

		},
		onGuideClose(key) {
			switch (key) {
				case PAGE.TRIP_FILES:
					this.isGuideDialogFile = false;
					break;
				case PAGE.TRIP_PAPER_WORK:
					this.isGuideDialogPaperWork = false;
					break;
			}
		},
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},

		onSaveNote(args, item) {
			const { comment } = args;
			if (item) {
				this.loads[this.activeLoadIndex].notes.map(obj => {
					if (obj.id === item.id ) {
						obj.comment = comment;
						obj.status = "edit";
					}
				});
			} else {
				const result = {
					comment,
					del: 1,
					create_at: null,
					dispatcher_id: null,
					dispatcher_name: null,
					id: null,
					status: "new",
					load_id: this.activeLoad.load_id
				};
				this.loads[this.activeLoadIndex].notes.push(result);
			}
			this.activeItem = null;
			this.isDialogNote = false;
		},
		onCloseNoteDialog() {
			this.isDialogNote = false;
			this.activeItem = null;
		},

		onAddItem(args, index) {
			const { nameComponent, load } = args;
			this.activeItem = null;
			this.activeLoad = load;
			this.activeLoadIndex = index;
			switch (nameComponent) {
				case PAGE.TRIP_PAYMENTS:
					this.isPaymentsDrawer = true;
					break;
				case PAGE.TRIP_NOTES:
					this.isDialogNote = true;
					break;
			}

		},
		onEditItem(args, index) {
			console.log('%c [  args  ] ', 'color:#bada55', typeof args, args );
			const { key, item, nameComponent, itemIndex, load } = args;

			this.activeItem = item;
			this.activeItemIndex = itemIndex;
			this.activeLoad = load;
			this.activeLoadIndex = index;

			switch (nameComponent) {
				case PAGE.TRIP_PAYMENTS:
					switch (key) {
						case "delete":
							this.titleRemove = TITLE.REMOVE_PAYMENT;
							this.textRemove = TEXT.REMOVE_PAYMENT;
							this.flagRemove = KEY.PAYMENT;
							this.textRemoveSave = 'YES';
							this.textRemoveClose = 'NO';
							this.isDialogRemove = true;
							break;
						case "edit":
							this.isPaymentsDrawer = true;
							break;
					}
					break;
				case PAGE.TRIP_NOTES:
					switch (key) {
						case "delete":
							this.titleRemove = TITLE.REMOVE_NOTES;
							this.textRemove = TEXT.REMOVE_NOTES;
							this.flagRemove = KEY.NOTE;
							this.textRemoveSave = 'YES';
							this.textRemoveClose = 'NO';
							this.isDialogRemove = true;
							break;
						case "edit":
							this.isDialogNote = true;
							break;
					}
					break;
				case PAGE.TRIP_FILES:
					
					switch (key) {
						case "delete":
							this.titleRemove = TITLE.REMOVE_FILES;
							this.textRemove = TEXT.REMOVE_FILES;
							this.flagRemove = KEY.FILE;
							this.textRemoveSave = 'YES';
							this.textRemoveClose = 'NO';
							this.isDialogRemove = true;
							break;
						case "view":
							this.linkPreviewDoc = getAppUrl + item.image;
							break;
					}
					break;
			}
		},

		onRemove() {
			const index = this.activeLoadIndex;

			this.isDialogRemove = false;

			switch (this.flagRemove) {
				case KEY.LOAD:
					this.loads[index].status = "deleted";
					this.loads[index].load_type = "Partial";
					this.loads[index].load_type_id = 2;
					this.loads[index].type.id = 2;
					this.loads[index].type.value = "Partial";
					break;
				case KEY.PAYMENT:
					this.activeItem.status = 'delete';
					this.updateLoadGross(this.activeLoad.load_id);
					break;
				case KEY.PPW_FILE:
					this.updateRemovePPWFile();
					break;
				case KEY.BILLING_INVOICED:
					this.updateRemoveBillingInvoiced();
					break;
				case KEY.NOTE:
					this.activeItem.status = 'delete';
					this.loads = getClonedArray(this.loads);
					break;
				case KEY.FILE:
					if (this.activeItem.status === 'new') {
						this.loads[index].file.splice(this.activeItemIndex, 1);
					} else {
						this.activeItem.status = 'deleted';
						this.loads = getClonedArray(this.loads);
					}
					break;
				case KEY.TRIP:
					this.$emit('updateRemoveTrip', this.flag);
					break;
				case 'gptFileError':
					this.onAddImportGPT();
					this.isGPTFileError = false;
					break;
				case 'gptFileSuccess':
					this.isGPTFileSuccess = false;

					break;
				case KEY.PICKUP:
				case KEY.DELIVERY:
					this.isShowMapBTN = false;
					this.loads[index][this.flagRemove].splice(this.activeItem, 1);
					break;
			}
		},

		onCloseRemove() {
			this.isDialogRemove = false;
		},

		onPaymentsDrawerClose() {
			this.isPaymentsDrawer = false;
			this.activeItem = null;
		},
		onPaymentsDrawerSave(args, editPayment) {
			const { amount, considerBoolean, msg, type } = args;
			const considerResult = considerBoolean ? 1 : 2;
			if (editPayment) {
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].amount = amount;
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].consider = considerResult;
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].msg = msg;
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].type = type;
			} else {
				const result = {
					amount,
					consider: considerResult,
					msg,
					type,
					create_at: null,
					id: null,
					status: "active",
					load_id: this.activeLoad.load_id
				};
				this.loads[this.activeLoadIndex].payments.push(result);
			}
			this.activeItem = null;
			this.isPaymentsDrawer = false;

			this.updateLoadGross(this.activeLoad.load_id);
		},
		updateLoadGross(id) {

			const filteredArray = this.loads.find(item => item.load_id === id);
			const filteredArrayConsider = filteredArray.payments.filter(obj => obj.consider === 1);
			filteredArray.gross = parseFloat(filteredArray.rate);
			filteredArrayConsider.map(item => {
				const { type, amount, status } = item;

				if (status !== 'delete') {
					filteredArray.gross = type === 3 ? filteredArray.gross - amount : filteredArray.gross + amount;
				}
			});
			filteredArray.gross = filteredArray.gross.toFixed(2);

			// this.loads.map(obj => {
			// 	const { load_id, rate } = obj;
			// 	if (id === load_id) {
			// 		const filteredArrayConsider = obj.payments.filter(obj => obj.consider === 1);
			// 		obj.gross = parseFloat(rate);
			// 		filteredArrayConsider.map(item => {
			// 			const { type, amount, status } = item;
			//
			// 			if (status !== 'delete') {
			// 				obj.gross = type === 3 ? obj.gross - amount : obj.gross + amount;
			// 			}
			// 		});
			// 		obj.gross = obj.gross.toFixed(2);
			// 	}
			// });

			this.totalGross = 0;
			this.loads.map(load => {
				const { gross, tarp } = load;
				this.totalGross = parseFloat(this.totalGross) + parseFloat(gross);
				if (tarp) this.totalGross = parseFloat(this.totalGross) + parseFloat(this.driver.tarp);

			});
			this.updateTotalRPM();
		},
		onRemoveLoad(load, index) {
			this.activeLoad = load;
			this.activeLoadIndex = index;
			this.titleRemove = TITLE.REMOVE_LOAD;
			this.textRemove = `${ TEXT.REMOVE_LOAD }${ this.activeLoad.load_id }?`;
			this.flagRemove = KEY.LOAD;
			this.textRemoveSave = 'YES';
			this.textRemoveClose = 'NO';
			this.isDialogRemove = true;
		},

		closeDialogCreatingBroker() {
			this.isCreatingBroker = false;
			this.searchText = null;
			this.searchMc = null;
			this.searchTextIndex = null;
		},
		async onCreatingBroker(args) {
			const { broker, broker_mc } = args;

			await this.addNewBrokersTripDialog({ value: broker, mc: broker_mc });

			const { broker_id, value, mc } = this.tripDialogDriverNewBrokers;

			this.createdBrokerForGPT = {
				id: broker_id,
				value,
				mc
			};

			const i = this.searchTextIndex;

			if (this.isAddImportGPT) {
				console.log('%c [  this.isAddImportGPT  ] ', 'color:#bada55', typeof this.isAddImportGPT, this.isAddImportGPT );
			} else if (i !== null && this.loads[i]) {
				this.loads[i].broker_name = value;
				this.loads[i].broker_id = broker_id;
				this.loads[i].mc = mc;

				this.loads = getClonedArray(this.loads);
			}

			this.closeDialogCreatingBroker();
		},

		onInputGPT(obj, index) {
			// const { name, key } = obj;
			console.log('%c [ onInputGPT obj  ] ', 'color:#bada55', typeof obj, obj );
			console.log('%c [ onInputGPT index  ] ', 'color:#bada55', typeof index, index );

		},
		onSearchText(obj, index) {
			const { name, key, mc } = obj;
			console.log('%c [  obj  ] ', 'color:#bada55', typeof obj, obj );
			console.log('%c [  index  ] ', 'color:#bada55', typeof index, index );

			this.searchText = name;
			this.searchTextIndex = index;

			if (key === 'broker') {
				this.searchMc = mc;
				this.isCreatingBroker = true;
			}
		},
		onSearchTextPickup(obj) {
			const { args, index } = obj;
			const { name } = args;

			this.searchText = name;
			this.searchTextIndex = index;
		},

		onLoadAutocomplete(args, index) {
			const { value, key, id } = args;
			console.log('%c [  args  ] ', 'color:#bada55', typeof args, args );
			this.loads[index][key] = value.value;
			this.loads[index][id] = value.id;

			if (key === 'load_type' && id === 'load_type_id') this.loads[index].type = { value: value.value, id: value.id };

			if (key === 'broker_name') {
				this.loads[index]['broker_name'] = value.value;
				this.loads[index]['broker_id'] = value.id;
				this.loads[index]['mc'] = value.mc;
			}
		},
		onLoadAutocompletePickup(obj, indexLoad) {
			const { args, flag, index } = obj;
			const { value, key } = args;
			if (value) {
				const { city, city_id, state, state_id, zip_code } = value;
				this.loads[indexLoad][flag][index][key].city = city;
				this.loads[indexLoad][flag][index][key].city_id = city_id;
				this.loads[indexLoad][flag][index][key].state = state;
				this.loads[indexLoad][flag][index][key].state_id = state_id;
				this.loads[indexLoad][flag][index][key].zip_code = zip_code;
			} else {
				this.loads[indexLoad][flag][index][key].city = null;
				this.loads[indexLoad][flag][index][key].city_id = null;
				this.loads[indexLoad][flag][index][key].state = null;
				this.loads[indexLoad][flag][index][key].state_id = null;
				this.loads[indexLoad][flag][index][key].zip_code = null;
			}
			this.loads = getClonedArray(this.loads);
		},
		onLoadGuide(args) {
			const { nameComponent } = args;
			if (nameComponent === PAGE.TRIP_FILES) this.isGuideDialogFile = true;
			if (nameComponent === PAGE.TRIP_PAPER_WORK) this.isGuideDialogPaperWork = true;
			// модалки для билинга пока нет
			if (nameComponent === PAGE.TRIP_BILLING) this.isGuideDialogPaperWork = true;
		},
		onLoadSwitch(args, index) {
			const { value, key } = args;

			if (key === 'tarp') {
				const tarp = this.driver.tarp ? parseFloat(this.driver.tarp) : 0;
				this.totalGross += value ? tarp : -tarp;
			}

			this.loads[index][key] = value;
		},
		onLoadInput(args, index) {
			const { value, key, parent } = args;

			if (parent) {
				this.loads[index][parent][key] = value;
			} else if (!(key in this.loads[index])) {
				// если поля нет добавляем реактивно
				this.$set(this.loads[index], key, value);
			} else {
				this.loads[index][key] = value;
			}

			if (key === 'rate') {
				this.updateLoadGross(this.loads[index].load_id);
			}

			if (key === 'pick_up_mileage' || key === 'mileage_empty') {
				this.loads[index].mileage_total =
						Number(this.loads[index].mileage_empty) +
						Number(this.loads[index].pick_up_mileage);

				this.updateLoadTotalMileage();
			}

			if (key === 'broker_number') {
				this.loads[index].customer_load = value;
			}
		},
		updateLoadTotalMileage() {
			this.totalMileage = 0;
			this.loads.map(obj => {
				const { mileage_empty, pick_up_mileage } = obj;
				this.totalMileage = Number(this.totalMileage) + Number(mileage_empty) + Number(pick_up_mileage);
			});
			this.updateTotalRPM();
		},
		updateTotalRPM() {
			const totalRPM = parseFloat(this.totalGross) / parseFloat(this.totalMileage);
			this.totalRPM = this.totalGross !== 0 && this.totalMileage !== 0 ? totalRPM.toFixed(2) : 0;
		},
		onLoadDeleteItemPickup(obj, indexLoad) {
			const { flag, index } = obj;

			this.activeItem = index;
			this.activeLoadIndex = indexLoad;
			this.flagRemove = flag;
			switch (flag) {
				case KEY.PICKUP:
					this.titleRemove = TITLE.DELETE_PICKUP;
					this.textRemove = TEXT.DELETE_PICKUP;
					break;
				case KEY.DELIVERY:
					this.titleRemove = TITLE.DELETE_DELIVERY;
					this.textRemove = TEXT.DELETE_DELIVERY;
					break;
			}
			this.textRemoveSave = 'YES';
			this.textRemoveClose = 'NO';
			this.isDialogRemove = true;
		},
		onLoadPickupInput(obj, indexLoad) {
			this.isShowMapBTN = false;
			const { args, flag, index } = obj;
			const { value, key } = args;

			this.loads[indexLoad][flag][index][key] = value;
			this.loads = getClonedArray(this.loads);
		},
		onAutocomplete({ value }, key) {
			if (key === 'driver') {
				const { filterTruck, filterTraller } = this.tripDialog;

				const { customer_billing, tarp, customer } = value;
				const driverTarp = this.driver.tarp ? this.driver.tarp : 0;
				const driverNewTarp = tarp ? tarp : 0;

				this.customer = customer;

				this.filterTruckList = filterTruck.filter(item => item.customer === this.customer);

				this.filterTrailerList = (filterTraller || []).filter(item =>
					typeof item?.value === 'string' &&
						this.customer &&
						item.value.includes(this.customer)
				);

				this.driver.tarp = tarp ? tarp : 0;
				this.tarp = tarp ? tarp : 0;

				this.loads.map((load) => {
					if (load.tarp) {
						this.totalGross = this.totalGross - driverTarp;
						this.totalGross = this.totalGross + driverNewTarp;
					}
					load.customer_billing = !!customer_billing;
				});
			}

			this[key] = value;

			// if (key === 'driver' || key === 'truck') {
			if (key === 'driver') {
				const trip_id = this.flag === 'new' ? false : this.trip_id;
				const params = {
					trip_id,
					[key]: value
				};
				this.dialogConnections(params);
			}
		},
		async dialogConnections(params) {
			await this.getTripDialogConnections(params);
			await this.updateConnections();
		},

		onSaveValue(file) {
			this.loads[0].file[0] = {
				created_at: this.getDateTime(),
				description: file.name,
				dispatcher_id: this.dispatcher.id,
				dispatcher_name: this.dispatcher.value,
				image: null,
				load_id: null,
				load_image_id: null,
				newFile: file.value,
				status: "new",
				to_invoice: null,
				type: 1,
				typeName: "Confirmation",
			};
			this.file.name = file.name;
			this.file.value = file.value;
		},
		getDateTime() {
			const now = new Date();

			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, "0");
			const day = String(now.getDate()).padStart(2, "0");

			const hours = String(now.getHours()).padStart(2, "0");
			const minutes = String(now.getMinutes()).padStart(2, "0");
			const seconds = String(now.getSeconds()).padStart(2, "0");

			return `${ year }-${ month }-${ day } ${ hours }:${ minutes }:${ seconds }`;
		},
		extractGPTUpdate(args) {
			this.ai_status = true;
			const { error } = args;
			if (error) {
				this.isGPTFileError = true;
			} else {
				this.isGPTFileSuccess = true;

				// 1) обновляем driver / truck / customer как и раньше
				this.driver = this.filterDriverList.find(item => item.id === args.driver_id);
				this.truck = this.filterTruckList.find(item => item.id === args.truck_id);
				// this.customer = this.truck.customer;

				const locationList = this.defaultLocation;
				if (!Array.isArray(locationList) || !locationList.length) {
					console.warn('[extractGPTUpdate] defaultLocation is empty/not array');
				}

				// 2) нормализация loads
				let extractedLoads = [];
				if (Array.isArray(args?.loads)) {
					extractedLoads = args.loads;
				} else if (args?.loads && typeof args.loads === 'object') {
					extractedLoads = [ args.loads ];
				} else if (Array.isArray(args)) {
					extractedLoads = args;
				} else if (args && typeof args === 'object') {
					if (args.locations_pickup || args.locations_delivery) {
						extractedLoads = [ args ];
					}
				}

				if (!extractedLoads.length) {
					console.warn('[extractGPTUpdate] normalized extractedLoads is empty → skip', args);
					return;
				}
				if (!Array.isArray(this.loads) || !this.loads.length) {
					console.warn('[extractGPTUpdate] this.loads empty → skip');
					return;
				}

				const dtn = this.getDateTime();

				const round2 = val =>
					val != null && !isNaN(val) ? Number(val).toFixed(2) : val;

				const isSet = v => v !== undefined && v !== null && !(typeof v === 'string' && v.trim() === '');
				const cleanVal = v => (typeof v === 'string' ? v.trim() : v);

				const preferManual = (manual, auto, fallback) => {
					if (isSet(manual)) return cleanVal(manual);
					if (isSet(auto)) return cleanVal(auto);
					if (isSet(fallback)) return cleanVal(fallback);
					return null;
				};

				// 3) ⚠️ ИСПРАВЛЕННЫЙ блок сборки next0 (только тут изменения)
				const p = extractedLoads[0] || {};
				const base0 = this.loads[0] || {};
				// будуємо нотатку, якщо p.notes є і не порожній
				const noteFromGPT =
							p.notes != null && String(p.notes).trim() !== ''
								? {
									comment: String(p.notes),
									create_at: dtn,
									created_at: dtn,
									del: 1,
									dispatcher_id: this.dispatcher.id,
									dispatcher_name: this.dispatcher.value,
									edit_at: dtn,
									id: null,
									load_id: base0.load_id, // важливо: прив’язка до поточного load_id
									status: "new",
								}
								: null;

				// якщо треба — можеш захиститись від дублікатів за текстом коментаря
				const prevNotes = Array.isArray(base0.notes) ? base0.notes.slice() : [];
				const notesMerged =
							noteFromGPT && !prevNotes.some(n => n && n.comment === noteFromGPT.comment)
								? [ noteFromGPT, ...prevNotes ]
								: prevNotes;

				const next0 = {
					...base0,

					// auto з GPT
					...(isSet(p.broker_load) ? { customer_load: p.broker_load, broker_number: p.broker_load } : {}),
					...(isSet(p.rate) ? { rate: Number(p.rate) } : {}),

					// manual (з кореня args) має вищий пріоритет
					broker_id: preferManual(args?.broker_id, p?.broker_id, base0?.broker_id),
					broker_name: preferManual(args?.broker_name, p?.broker_name, base0?.broker_name),
					mc: preferManual(p?.mc, null, base0?.mc),

					// нотатки
					...(notesMerged.length ? { notes: notesMerged } : {}),

					load_type: "Full",
					load_type_id: 1,
				};

				next0.mileage_total = round2(
					(parseFloat(next0.mileage_empty) || 0) +
							(parseFloat(next0.pick_up_mileage) || 0)
				);

				// замена loads[0] + «пинок» реактивности массива
				this.$set(this.loads, 0, next0);
				this.loads = this.loads.slice();

				// 4) маппинг pickup/delivery (как у тебя было)
				const mapped = this.loads.map((load, i) => {
					const src = extractedLoads[i];
					if (!src) return load;

					const pickups = (src.locations_pickup || []).map((raw, idx) =>
						buildStop(raw, { type: 0, locationList, loadId: load?.load_id, index: idx })
					);
					const deliveries = (src.locations_delivery || []).map((raw, idx) =>
						buildStop(raw, { type: 1, locationList, loadId: load?.load_id, index: idx })
					);

					return { ...load, pickup: pickups, delivery: deliveries };
				});

				mapped.forEach((l, i) => {
					const safe = {
						...l,
						pickup: Array.isArray(l.pickup) ? l.pickup.slice() : [],
						delivery: Array.isArray(l.delivery) ? l.delivery.slice() : [],
					};
					this.$set(this.loads, i, safe);
				});

				// доп. «пин-к» (оставил как у тебя)
				this.loads = this.loads.map(l => ({
					...l,
					pickup: (l.pickup || []).slice(),
					delivery: (l.delivery || []).slice(),
				}));

				// Пересчитать суммарные метрики после подстановки
				this.updateLoadTotalMileage();

				// валидаторы Vuelidate (как у тебя) + touch
				if (this.$v?.loads) {
					this.$v.loads.$reset();
					this.$nextTick(() => this.$v.loads.$touch());
				}

				if (this.loads[0].pickup.length > 0 && this.loads[0].delivery.length > 0) {
					this.onGetMileageLoaded({ load: this.loads[0], index: 0 });
					this.onGetMileageEmpty({ load: this.loads[0], index: 0 });
				}

				this.validateAllNow();
			}
		},

		validateAllNow() {
			if (!this.$v) return;
			// 1) сбрасываем "грязность", чтобы пересобрались пути для $each
			this.$v.$reset();

			// 2) ждём обновления реактивности (массивы loads/pickup/delivery уже заменены)
			this.$nextTick(() => {
				// доступ к ветке loads.$each заставит Vuelidate заново построить итераторы
				void this.$v.loads && this.$v.loads.$each;

				// 3) ещё один тик — и «трогаем» всё дерево
				this.$nextTick(() => {
					this.$v.$touch();
				});
			});
		},

		async onAddLoad() {
			const trip_id = this.flag === 'new' ? null : this.trip_id;
			const loadId = await this.getIdLoad({ trip_id });
			const newLoad = {
				amount_extra_stop: null,
				billing: {
					create_at: null,
					date: null,
					file: null,
					id: null,
					invoice_by: null,
					load_id: null,
					status: false,
					update_at: null,
					user_id: null,
				},
				billing_freight_amount: null,
				billing_mile: null,
				billing_total: null,
				billing_type: null,
				billing_weight: null,
				broker_id: null,
				mc: null,
				broker_name: null,
				created_at: null,
				customer_billing: false,
				customer_load: null,
				delivery: [
					{
						app: null,
						city: null,
						city_id: null,
						company: null,
						date_time: null,
						id: null,
						load_id: null,
						loction: {
							city: null,
							city_id: null,
							state: null,
							state_id: null,
							zip_code: null,
						},
						number: null,
						phone: null,
						shipper: null,
						shipper_id: null,
						state: null,
						state_id: null,
						street: null,
						type: 0,
						zip_code: null,
					}
				],
				delivery_city: null,
				delivery_datetime: null,
				delivery_state: null,
				dimonsions: {
					height_from: null,
					height_to: null,
					length_from: null,
					length_to: null,
					width_from: null,
					width_to: null,
				},
				dispatcher: null,
				division_name: null,
				driver: null,
				driver_salary: null,
				factoring: null,
				file: [],
				gross: null,
				invoice_date: null,
				load_id: loadId,
				load_status_id: null,
				load_type: null,
				load_type_id: null,
				mileage_empty: null,
				nickname: null,
				notes: [],
				payments: [],
				pick_up_city: null,
				pick_up_datetime: null,
				pick_up_empty: null,
				pick_up_mileage: null,
				pick_up_state: null,
				pickup: [
					{
						app: null,
						city: null,
						city_id: null,
						company: null,
						date_time: null,
						id: null,
						load_id: null,
						loction: {
							city: null,
							city_id: null,
							state: null,
							state_id: null,
							zip_code: null,
						},
						number: null,
						phone: null,
						shipper: null,
						shipper_id: null,
						state: null,
						state_id: null,
						street: null,
						type: 0,
						zip_code: null,
					}
				],
				quantity: null,
				rate: null,
				special_instructions: null,
				split_from: null,
				split_to: null,
				status: "active",
				tarp: 0,
				tonu: 0,
				trailer: null,
				trailer_type: null,
				trip_id: null,
				truck: null,
				type: {
					id: 1,
					value: "Full",
				},
				weight: null,
				сarrier: null,
			};
			this.loads.push(newLoad);
			this.loads = getClonedArray(this.loads);
		},
		onRemoveTrip() {
			this.titleRemove = TITLE.REMOVE_TRIP;
			this.textRemove = `${ TEXT.REMOVE_TRIP }${ this.flag }?`;
			this.flagRemove = KEY.TRIP;
			this.textRemoveSave = 'YES';
			this.textRemoveClose = 'NO';
			this.isDialogRemove = true;
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					dispatcher,
					division,
					division_id,
					driver,
					frozen,
					loads,
					mileage_trip,
					old_route,
					secDriver,
					trailer,
					trip_id,
					truck,
					ai_status,
				} = this.$data;

				const value = {
					dispatcher,
					division,
					division_id,
					driver,
					frozen,
					loads,
					mileage_trip,
					old_route,
					secDriver,
					trailer,
					trip_id,
					truck,
					ai_status,
				};

				const id = await this.saveTrip(value);
				this.onOpenOldTrip(id);

				this.isSaveStatus = true;

			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		},
		closeDialog() {
			this.$emit('updateClosePopup', this.isSaveStatus);
		},
		updateConnections() {
			const { customer, trailer, truck, driver, old_route } = this.tripDialogConnections;
			if (truck) this.truck = truck;
			if (trailer) this.trailer = trailer;
			if (Array.isArray(driver) && driver.length > 0 && driver[0] != null) this.driver = driver[0];
			if (Array.isArray(driver) && driver.length > 0 && driver[1] != null) this.driverSecond = driver[1];
			if (customer) this.frozen = customer ? customer.frozen : null;
			if (customer) this.customer = customer ? customer.value : null;
			if (trailer) this.trailerType = trailer ? trailer.trailer_type : null;
			if (old_route) {
				this.old_route = Array.isArray(old_route) ? null : old_route;
				this.loads.map(obj => {
					const { pick_up_mileage } = obj;
					obj.mileage_total = pick_up_mileage;
					obj.mileage_empty = null;
					obj.pick_up_empty = null;
				});
			}
		},

		updateTripDialog() {
			const { dispatcher_id, filterDispatcher, filterDriver, filterLoadFiletType, filterTraller, filterTruck, service, trip, location, dispatcher } = this.tripDialog;
			const driverNull = {
				id: null,
				tarp: null,
				value: null,
			};

			this.filterDriverList = filterDriver;
			this.filterDispatcherList = filterDispatcher;
			this.filterLoadFiletTypeList = filterLoadFiletType;
			this.filterTrailerList = filterTraller;
			this.filterTrailerListALL = filterTraller;
			this.filterTruckList = filterTruck;
			this.filterTruckListAll = filterTruck;
			this.serviceList = service;
			this.defaultLocation = location;
			this.dispatcher_id = dispatcher_id;

			if (trip) {
				const {
					dispatcher,
					division,
					division_id,
					driver,
					frozen,
					loads,
					mileage_trip,
					old_route,
					secDriver,
					tarp,
					trailer,
					trip_id,
					truck,
					bill_factoring,
				} = trip;
				this.bill_factoring = bill_factoring;
				this.dispatcher = dispatcher;
				this.division = division;
				this.division_id = division_id;
				this.driver = driver ? driver : driverNull;
				this.frozen = frozen;
				this.loads = loads;
				this.mileage_trip = mileage_trip;
				this.old_route = Array.isArray(old_route) ? null : old_route;
				this.secDriver = secDriver;
				this.tarp = tarp;
				this.trailer = trailer;
				this.trip_id = trip_id;
				this.truck = truck;
				this.trailerType = trailer.trailer_type;
				this.customer = truck.customer;

				this.dialogSubTitle = this.trip_id;
			} else {
				this.dispatcher = dispatcher[0];
				this.dispatcher_id = dispatcher[0].id;
			}
			this.updateTotalGross();
			this.updateLoadTotalMileage();
		},
		updateTotalGross() {
			this.totalGross = 0;
			this.loads.map(load => {
				const { gross } = load;
				this.totalGross = this.totalGross + Number(gross);
			});
		},
		async onOpenOldTrip(id) {
			await this.getTripDialog(id);
			this.updateTripDialog();
			await this.getTripDialogBrokers();
		},
		updateLoadGrossStart() {
			this.loads.map(obj => {
				const { load_id, tarp } = obj;
				if (tarp) this.updateLoadGross(load_id);
			});
			this.isShowMap = true;
		},
	},
	async mounted() {
		await this.getTripDialog(this.flag);
		if (this.flag === 'new') this.onAddLoad();
		await this.getTripDialogBrokers();
		this.updateTripDialog();
		this.updateLoadGrossStart();
		this.ai_status = false;
	},
};
</script>

<style scoped lang="scss">
@import "DialogTrip";
.wrapperMap {
	margin-top: 20px;
}
.mapValidationError {
	margin-top: 8px;
	font-size: 12px;
	line-height: 1.3;
	color: var(--card-color-sub-title); // vuetify red accent-ish
}
</style>
